<template>
  <div class="px-4 sm:px-6 lg:px-8">
    <div class="sm:flex sm:justify-between sm:items-center">
        <select v-model="query.component_type" name="country" autocomplete="country-name" class="sm:hidden mt-3 mr-4 w-48 inline-block bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
          <option :value="4" :selected="query.component_type === 4">应用规则</option>
          <option :value="0" :selected="query.component_type === 0">功能组件</option>
          <option :value="1" :selected="query.component_type === 1">子流程</option>
          <option :value="3" :selected="query.component_type === 3">大组件</option>
          <option :value="8" :selected="query.component_type === 8">流程模板</option>
        </select>
        <nav class="space-x-4 hidden sm:block pb-4 mt-3" aria-label="Tabs">
        <a href="#" @click="query.component_type = 4" :class="[query.component_type === 4 ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700']" class="px-3 py-1 font-medium text-sm rounded-md">应用规则</a>
        <a href="#" @click="query.component_type = 0" :class="[query.component_type === 0 ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700']" class="px-3 py-1 font-medium text-sm rounded-md">功能组件</a>
        <a href="#" @click="query.component_type = 1" :class="[query.component_type === 1 ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700']" class="px-3 py-1 font-medium text-sm rounded-md">子流程</a>
        <a href="#" @click="query.component_type = 3" :class="[query.component_type === 3 ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700']" class="px-3 py-1 font-medium text-sm rounded-md">大组件</a>
        <a href="#" @click="query.component_type = 8" :class="[query.component_type === 8 ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700']" class="px-3 py-1 font-medium text-sm rounded-md">流程模板</a>
        </nav>
        <input v-model="query.keyword" type="text" name="first-name" placeholder="关键字筛选" autocomplete="given-name" class=" -mt-2 mr-4 inline-block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
    </div>
    <div class="mt-4 flex flex-col">
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="min-w-full divide-y divide-gray-300">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">ID</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">名称</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">版本</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">创建时间</th>
                  <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                    <span class="sr-only">操作</span>
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white">
                <tr v-for="item in tableData" :key="item.id">
                  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">{{item.id}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.name}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.version}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.create_time}}</td>
                  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" title="查看版本列表" @click="view(item)">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z" />
                      </svg>
                    </a>
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" title="下载到火语言本地客户端"  @click="download(item)">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
                      </svg>

                    </a>
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" @click="shareFlow(item)" :title="getShareTitle(item)">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z" />
                      </svg>
                    </a>
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" title="删除" @click="deleteItem(item)">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                      </svg>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Pagination :size="query.size" :page="query.page" :total="total" @change="changePage" />
    <Alert :visible.sync="alertShow" ref="alert" />
    <Notify ref="notify" />
    <Modal :visible.sync="versionDialog" title="版本列表" :ActionBtnShow="false" width="max-w-3xl">
      <div class="space-y-6 sm:space-y-0 sm:py-0 my-4 mx-2 ring-1 ring-black ring-opacity-5">
        <table class="min-w-full divide-y divide-gray-300">
          <thead class="bg-gray-50">
            <tr>
              <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">版本</th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">下载次数</th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">标签</th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">创建时间</th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">简介</th>
              <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                <span class="sr-only">操作</span>
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 bg-white">
            <tr v-for="(item, index) in versions" :key="item.id">
              <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">{{item.version}}</td>
              <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.down_count}}</td>
              <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.tags}}</td>
              <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.create_time}}</td>
              <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.summary}}</td>
              <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" @click="deleteVersion(item, index)">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                  </svg>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Modal>
    <Modal :visible.sync="shareInfoDialog" :title="'分享：'+form.Name" :ActionBtnShow="false" width="max-w-xl">
      <div class="space-y-6 sm:space-y-0 sm:py-0 my-4" v-if="step === 1">
        <div class="text-sm my-1 px-4 py-2" style="background-color: #f0f9eb;" v-if="shareList.length">
          <svg class="h-6 w-6 text-green-400 inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          该资源存在已分享的链接！</div>
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8" v-if="shareList.length">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="min-w-full divide-y divide-gray-300">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="px-3 py-1 text-left text-sm font-medium text-gray-900">创建时间</th>
                  <th scope="col" class="px-3 py-1 text-left text-sm font-medium text-gray-900">提取码</th>
                  <th scope="col" class="px-3 py-1 text-left text-sm font-medium text-gray-900">有效期</th>
                  <th scope="col" class="relative py-1 pl-3 pr-4 sm:pr-6 text-sm font-medium text-gray-900 text-center">
                    <span>操作</span>
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white">
                <tr v-for="item in shareList" :key="item.id">
                  <!-- <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">{{item.Id}}</td> -->
                  <!-- <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"><a :href="`${protocol}//www.huoyuyan.com/share.html?key=${item.ShareKey}`" class="text-indigo-600" target="_blank">{{item.Name}}</a></td> -->
                  <!-- <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{componentTypes[item.ComponentType]}}</td> -->
                  <!-- <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.Version}}</td> -->
                  <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{item.AddTime}}</td>
                  <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{item.Code}}</td>
                  <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                    <template v-if="item.ExpirationTime === 0">永久</template>
                    <template v-else>{{item.ExpirationTime}}天</template>
                  </td>
                  <!-- <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <span v-if="item.IsValid" class="text-green-600">是</span>
                    <span class="text-red-500" v-else>否</span>
                  </td> -->
                  <!-- <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.DownloadCount}}</td> -->
                  <td class="relative whitespace-nowrap py-1 pl-3 pr-4 text-center text-sm font-medium sm:pr-6">
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" @click="copyLink(item)" title="复制链接">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-4 w-4 text-gray-500">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
                      </svg>
                    </a>
                    <a :href="`${protocol}//dev.www.huoyuyan.com/share.html?key=${item.ShareKey}`" class="text-gray-500 hover:text-gray-900 inline-block mr-1" target="_blank" title="浏览器直接打开">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-4 w-4 text-gray-500">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
                      </svg>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-5 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2 text-right">有效期：</label>
          </div>
          <div class="sm:col-span-4">
            <div class="sm:flex sm:items-center sm:space-y-0 sm:space-x-10 sm:pt-2">
              <div class="flex items-center cursor-pointer" @click="form.ExpirationTime = 1">
                <input name="notification-method" :value="1" type="radio" :checked="form.ExpirationTime === 1" class="cursor-pointer focus:ring-transparent h-4 w-4 text-indigo-600 border-gray-300">
                <label for="email" class="ml-3 block text-sm font-medium text-gray-700 cursor-pointer">1天</label>
              </div>

              <div class="flex items-center cursor-pointer" @click="form.ExpirationTime = 7">
                <input name="notification-method" :value="7" type="radio" :checked="form.ExpirationTime === 7" class="cursor-pointer focus:ring-transparent h-4 w-4 text-indigo-600 border-gray-300">
                <label for="sms" class="ml-3 block text-sm font-medium text-gray-700 cursor-pointer">7天</label>
              </div>

              <div class="flex items-center cursor-pointer" @click="form.ExpirationTime = 30">
                <input name="notification-method" :value="30" type="radio" :checked="form.ExpirationTime === 30" class="cursor-pointer focus:ring-transparent h-4 w-4 text-indigo-600 border-gray-300">
                <label for="push" class="ml-3 block text-sm font-medium text-gray-700 cursor-pointer">30天</label>
              </div>

              <div class="flex items-center cursor-pointer" @click="form.ExpirationTime = 0">
                <input name="notification-method" :value="0" type="radio" :checked="form.ExpirationTime === 0" class="cursor-pointer focus:ring-transparent h-4 w-4 text-indigo-600 border-gray-300">
                <label for="push" class="ml-3 block text-sm font-medium text-gray-700 cursor-pointer">永久</label>
              </div>
            </div>
          </div>
        </div>
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-5 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2 text-right">提取码：</label>
          </div>
          <div class="sm:col-span-4">
            <input v-model="form.Code" type="text" class="block w-20 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
          </div>
        </div>
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-5 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"></label>
          </div>
          <div class="sm:col-span-4" @click="form.AutoCode = !form.AutoCode">
            <input id="auto-code" name="notification-method" type="checkbox" :checked="form.AutoCode === true" class="cursor-pointer focus:ring-transparent h-4 w-4 text-indigo-600 border-gray-300">
            <label for="auto-code" class="text-sm cursor-pointer ml-1" @click="form.AutoCode = !form.AutoCode">分享链接自动填充提取码</label>
          </div>
        </div>
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-5 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"></label>
          </div>
          <div class="sm:col-span-4" @click="form.AutoCode = !form.AutoCode">
            <button @click="submitShare()" type="button" class="mt-4 w-40 text-center items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">创建分享链接</button>
          </div>
        </div>
      </div>
      <div class="space-y-6 sm:space-y-2 sm:py-0 m-4" v-else>
        <div class="text-sm my-1 px-4 py-2" style="background-color: #f0f9eb;">
          <svg class="h-6 w-6 text-green-400 inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          成功创建分享链接<template v-if="form.AutoCode">(该链接可自动填充提取码)</template></div>
        <div class="">
          <input v-model="url" type="text" disabled autocomplete="off" name="project-name" class="cursor-not-allowed block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" style="background-color: #F5F7FA;border-color: #E4E7ED;color: #C0C4CC;">
        </div>
        <div class="text-sm">
          提取码：<input v-model="form.Code" type="text" disabled class="inline-block w-20 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" style="background-color: #F5F7FA;border-color: #E4E7ED;color: #C0C4CC;">
        </div>
        <div class="text-sm">该链接
          <span class="text-red-500 inline-block mx-1"><template v-if="form.ExpirationTime === 0">永久</template><template v-else>{{form.ExpirationTime}}天</template></span>
          <template v-if="form.ExpirationTime === 0">有效</template><template v-else>后失效</template>
        </div>
        <div>
          <button @click="copy()" type="button" class="mt-4 ml-4 w-40 text-center items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">复制链接及提取码</button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Pagination from '../components/Pagination.vue'
import Alert from '../components/Alert.vue'
import Notify from '../components/Notification.vue'
import { pageList, removeVersion, removeSync, shareInfo, share, shareList } from '../api/Task'
import { debounce } from 'lodash'
import Modal from '../components/Modal.vue'
const componentTypes = { 4: '应用规则', 0: '功能组件', 1: '子流程', 3: '大组件', 8: '流程模板' }
export default {
  name: 'TaskList',
  components: { Alert, Notify, Pagination, Modal },
  data () {
    return {
      alertShow: false,
      modalShow: false,
      versionDialog: false,
      shareInfoDialog: false,
      query: {
        page: 1,
        size: 10,
        keyword: '',
        component_type: 4,
        sort: '-id'
      },
      key: '',
      versions: [],
      tableData: [],
      total: 0,
      relationsData: {
        main: { name: '' },
        logics: [],
        components: [],
        complexs: []
      },
      row: {},
      step: 1,
      url: '',
      shareList: [],
      protocol: window.location.protocol,
      form: { Id: 0, Key: '', ComponentType: '', Name: '', Version: '', Summary: '', Code: '3243', AutoCode: true, ExpirationTime: 0, ExpirationTimeStamp: 0, Info: '', Remark: '' }
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getShareTitle (item) {
      return '分享' + componentTypes[item.component_type]
    },
    download (row) {
      const base64 = encodeURIComponent(JSON.stringify({
        type: 1,
        action: 'download_share_file',
        data: {
          defaultPath: `${row.name}.${row.component_type === 0 ? 'hyyc' : 'hyy'}`,
          remoteFile: `/cloud/sync/down/${row.component_type}/${row.key}/${row.version}`
        }
      }))
      const url = `hyy://${base64}`
      window.open(url)
      this.notifyShow({ title: '已跳转至火语言客户端下载文件！' })
    },
    getRelationTable (row) {
      this.row = row
      shareInfo(row).then(res => {
        const response = res.data.data
        response.Children.map(item => {
          const obj = { name: item.Name, key: item.Key, version: item.Version }
          if (item.ComponentType === 'common') {
            this.relationsData.components.push(obj)
          } else if (item.ComponentType === 'logic') {
            this.relationsData.logics.push(obj)
          } else {
            this.relationsData.complexs.push(obj)
          }
        })
        this.relationsData.main = { name: response.Name, key: response.Key, version: response.Version, type: response.ComponentType }
        this.shareInfoDialog = true
      }).catch((err) => {
        console.log(err)
      })
    },
    copy () {
      const text = `链接: ${this.url} 提取码: ${this.form.Code}`
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.notifyShow({ title: '链接及提取码已复制到剪切板', desc: '' })
            this.shareInfoDialog = false
            this.step = 1
          })
          .catch((err) => {
            console.error('无法复制此文本：', err)
          })
      } else {
        // 创建text area
        const textArea = document.createElement('textarea')
        textArea.value = text
        document.body.appendChild(textArea)
        textArea.style.position = 'absolute'
        textArea.style.opacity = 0
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        textArea.focus()
        textArea.select()
        return new Promise((resolve, reject) => {
          // 执行复制命令并移除文本框
          document.execCommand('copy') ? resolve() : reject(new Error('出错了'))
          textArea.remove()
        }).then(
          () => {
            this.notifyShow({ title: '链接及提取码已复制到剪切板', desc: '' })
          },
          (err) => {
            console.error('无法复制此文本：', err)
          }
        )
      }
    },
    copyLink (item) {
      const text = `${window.location.protocol}//dev.www.huoyuyan.com/share.html?key=${item.ShareKey}`
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.notifyShow({ title: '链接已复制到剪切板', desc: '' })
          })
          .catch((err) => {
            console.error('无法复制此文本：', err)
          })
      } else {
        // 创建text area
        const textArea = document.createElement('textarea')
        textArea.value = text
        document.body.appendChild(textArea)
        textArea.style.position = 'absolute'
        textArea.style.opacity = 0
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        textArea.focus()
        textArea.select()
        return new Promise((resolve, reject) => {
          // 执行复制命令并移除文本框
          document.execCommand('copy') ? resolve() : reject(new Error('出错了'))
          textArea.remove()
        }).then(
          () => {
            this.notifyShow({ title: '链接已复制到剪切板', desc: '' })
          },
          (err) => {
            console.error('无法复制此文本：', err)
          }
        )
      }
    },
    submitShare () {
      share(this.form).then((res) => {
        // this.notifyShow({ title: '分享成功，前往 用户中心--我的分享 栏目查看！' })
        // console.log(res)
        this.url = `${window.location.protocol}//dev.www.huoyuyan.com/share.html?key=${res.data.data.ShareKey}`
        this.step = 2
      })
    },
    shareFlow (row) {
      this.shareList = []
      shareList({ dataKey: row.key, PageIndex: 1, PageSize: 50 }).then(res => {
        this.shareList = res.data.data.list
      }).catch((err) => {
        console.log(err)
      })
      shareInfo({ key: row.key, version: row.version }).then(res => {
        if (!res.data.state) {
          this.notifyShow({ title: res.data.message, type: 'warn' })
          return
        }
        this.form = res.data.data
        this.form.Code = this.randomStr(4)
        this.step = 1
        this.shareInfoDialog = true
      }).catch((err) => {
        console.log(err)
      })
    },
    randomStr (len = 6) {
      const seeds = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      const maxPos = seeds.length
      let str = ''
      let i = 0
      for (i; i < len; i++) {
        str += seeds.charAt(Math.floor(Math.random() * maxPos))
      }
      return str
    },
    view (row) {
      this.versionDialog = true
      this.key = row.key
      this.versions = row.Versions
    },
    changePage (page) {
      this.query.page = page
    },
    notifyShow (msg = { title: '', desc: '', timeout: 3000 }) {
      this.$refs.notify.show(msg)
    },
    refreshData: debounce(
      function () {
        this.getList()
      },
      800
    ),
    getList () {
      this.loading = true
      pageList(this.query).then(res => {
        const data = res.data.data
        if (!data.list) data.list = []
        this.tableData = data.list
        this.query.page = data.page
        this.total = data.total
        // this.$refs.multipleTable.doLayout()
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    deleteItem (item) {
      this.alertShow = true
      new Promise((resolve, reject) => {
        const instance = this.$refs.alert
        instance.confirm = () => {
          this.alertShow = false
          resolve()
        }
        instance.cancel = () => {
          this.alertShow = false
          reject()
        }
      }).then(() => {
        removeSync(item.key).then(() => {
          this.notifyShow({ title: '删除成功' })
          this.getList()
        })
      }).catch(() => { console.log('cancel') })
    },
    deleteVersion (row, index) {
      this.alertShow = true
      new Promise((resolve, reject) => {
        const instance = this.$refs.alert
        instance.confirm = () => {
          this.alertShow = false
          resolve()
        }
        instance.cancel = () => {
          this.alertShow = false
          reject()
        }
      }).then(() => {
        removeVersion(this.key, row.version).then(() => {
          this.notifyShow({ title: '删除成功' })
          this.versions.splice(index, 1)
        })
      }).catch(() => { console.log('cancel') })
    }
  },
  watch: {
    query: {
      handler: function () {
        this.refreshData()
      },
      deep: true
    }
  }
}
</script>
